/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Col,
  Descriptions,
  Divider,
  Drawer,
  Empty,
  Row,
  Spin,
  Steps,
  Tooltip,
} from "antd";
import React from "react";
import { useGetActivityLog } from "./queries";
import { ClockIcon, CustomSpin, RightIconBW } from "../../assets/icons/icons";
import { convertUTCToLocal } from "../../utils/timeUtils";
import { getTrolleyStatus } from "../../components/reusable/styles";
import Icon, { InfoCircleOutlined } from "@ant-design/icons";

const ActivityLogs = ({ open, setOpen }: any) => {
  //utility
  const handleCancel = () => {
    setOpen({ open: false, details: null });
  };

  console.log(open?.details);

  const payload = open?.details?.trolley_id
    ? {
        payload: {
          trolley_id: open?.details?.trolley_id,
          run_id: open?.details?.trolley_movement_run,
        },
        url: "locationViewHistory",
      }
    : {
        payload: {
          tote_id: open?.details?.tote_id,
          run_id: open?.details?.trolley_movement_run,
        },
        url: "locationViewToteHistory",
      };

  // on mount calls
  const { data: d1, isLoading: l1 } = useGetActivityLog(payload);

  const activityDetails = open?.details?.trolley_id
    ? d1?.trolley_details_list?.[0]
    : d1?.tote_details_list?.[0];

  const getTrackingItems = () => {
    if (
      open?.details?.trolley_id
        ? !activityDetails?.trolley_movements
        : !activityDetails?.tote_movements
    )
      return [];

    const mainData = open?.details?.trolley_id
      ? activityDetails.trolley_movements
      : activityDetails?.tote_movements;

    return mainData?.map((m: any) => {
      const time = convertUTCToLocal(m.movement_timestamp);

      return {
        title: (
          <Col>
            <Row
              gutter={m?.from_location && m?.to_location ? 10 : 0}
              style={{
                color: "#101010",
                fontWeight: "600",
                fontSize: "16px",
              }}
            >
              <Col>
                <div>{m?.from_location}</div>
              </Col>
              {m?.from_location && m?.to_location && (
                <Col>
                  <Icon component={() => RightIconBW("#101010")} />
                </Col>
              )}
              <Col>
                <div>{m?.to_location}</div>
              </Col>
            </Row>
            <Row
              gutter={m?.from_sub_location && m?.to_sub_location ? 10 : 0}
              style={{
                color: "#0085ad",
                fontWeight: "500",
                fontSize: "14px",
              }}
            >
              <Col>
                <div>{m?.from_sub_location}</div>
              </Col>
              {m?.from_sub_location && m?.to_sub_location && (
                <Col>
                  <Icon component={() => RightIconBW("#0085ad")} />
                </Col>
              )}
              <Col>
                <div>{m?.to_sub_location}</div>
              </Col>
            </Row>
          </Col>
        ),
        description: (
          <div>
            <Row>
              <div
                style={{
                  color: getTrolleyStatus(m.action_type),
                  fontWeight: "600",
                  fontSize: "14px",
                }}
              >
                {m.action_type
                  ?.toLowerCase()
                  .split("_")
                  .map(
                    (word: any) => word.charAt(0).toUpperCase() + word.slice(1)
                  )
                  .join(" ")}
              </div>
              <Tooltip title={m?.remarks}>
                <InfoCircleOutlined
                  style={{ color: "#101010", marginLeft: "5px" }}
                />
              </Tooltip>
            </Row>
            <div style={{ color: "#101010", fontWeight: 500 }}>
              <Icon
                component={() => ClockIcon("#101010")}
                style={{ marginRight: "5px" }}
              />
              {time}
            </div>
          </div>
        ),
      };
    });
  };

  return (
    <Drawer
      open={open?.open}
      onClose={handleCancel}
      headerStyle={{ display: "none" }}
    >
      <Divider style={{ borderColor: "#00205b", color: "#0085ad" }}>
        Activity log
      </Divider>
      <Spin spinning={l1} indicator={<CustomSpin />}>
        <Descriptions
          column={1}
          size="small"
          labelStyle={{ width: "150px", fontWeight: 500 }}
          contentStyle={{ fontWeight: 600, color: "#101010" }}
        >
          <Descriptions.Item
            label={open?.details?.trolley_id ? "Trolley ID" : "Tote ID"}
          >
            {activityDetails?.trolley_serial_id ||
              activityDetails?.tote_serial_id}
          </Descriptions.Item>

          <Descriptions.Item label="Priority">
            {activityDetails?.trolley_priority ||
              activityDetails?.tote_priority}
          </Descriptions.Item>

          {open?.details?.trolley_id &&
            (activityDetails?.trolley_mdu ||
              activityDetails?.mdu ||
              open?.details?.mdu) && (
              <Descriptions.Item label="MDU">
                {activityDetails?.trolley_mdu ||
                  activityDetails?.mdu ||
                  open?.details?.mdu}
              </Descriptions.Item>
            )}

          {!open?.details?.trolley_id && (
            <>
              <Descriptions.Item label="MSN">
                {activityDetails?.tote_msn ||
                  activityDetails?.msn ||
                  open?.details?.msn ||
                  "N/A"}
              </Descriptions.Item>

              <Descriptions.Item label="USM">
                {activityDetails?.tote_usm ||
                  activityDetails?.usm ||
                  open?.details?.usm || activityDetails?.tote_usn ||
                  activityDetails?.usn ||
                  open?.details?.usn ||
                  "N/A"}
              </Descriptions.Item>
            </>
          )}

          <Descriptions.Item label="Registered Date">
            {convertUTCToLocal(
              activityDetails?.trolley_registered_on ||
                activityDetails?.tote_registered_on
            )}
          </Descriptions.Item>

          <Descriptions.Item label="Status">
            <div
              style={{
                color: getTrolleyStatus(
                  activityDetails?.trolley_status ||
                    activityDetails?.tote_status
                ),
              }}
            >
              {activityDetails?.trolley_status || activityDetails?.tote_status}
            </div>
          </Descriptions.Item>

          <Descriptions.Item label="Current Location">
            {activityDetails?.trolley_current_location ||
              activityDetails?.tote_current_location}
          </Descriptions.Item>

          {!open?.details?.trolley_id && (
            <>
              <Descriptions.Item label="Point of Delivery">
                {activityDetails?.tote_point_of_delivery ||
                  activityDetails?.point_of_delivery ||
                  open?.details?.point_of_delivery ||
                  "N/A"}
              </Descriptions.Item>

              <Descriptions.Item label="Date of Delivery">
                {activityDetails?.tote_date_of_delivery ||
                activityDetails?.date_of_delivery ||
                open?.details?.date_of_delivery
                  ? convertUTCToLocal(
                      activityDetails?.tote_date_of_delivery ||
                        activityDetails?.date_of_delivery ||
                        open?.details?.date_of_delivery
                    )
                  : "N/A"}
              </Descriptions.Item>

              <Descriptions.Item label="Point of Use / Station">
                {activityDetails?.tote_point_of_use ||
                  activityDetails?.point_of_use_station ||
                  activityDetails?.point_of_use ||
                  open?.details?.point_of_use ||
                  open?.details?.point_of_use_station ||
                  "N/A"}
              </Descriptions.Item>

              <Descriptions.Item label="Date of Use">
                {activityDetails?.tote_date_of_use ||
                activityDetails?.date_of_use ||
                open?.details?.date_of_use
                  ? convertUTCToLocal(
                      activityDetails?.tote_date_of_use ||
                        activityDetails?.date_of_use ||
                        open?.details?.date_of_use
                    )
                  : "N/A"}
              </Descriptions.Item>
            </>
          )}
        </Descriptions>

        {activityDetails?.trolley_movements?.length > 0 ||
        activityDetails?.tote_movements?.length > 0 ? (
          <Steps
            style={{ marginTop: "30px" }}
            direction="vertical"
            labelPlacement="horizontal"
            progressDot
            current={
              activityDetails.trolley_movements
                ? activityDetails.trolley_movements?.length
                : activityDetails?.tote_movements?.length
            }
            items={getTrackingItems()}
          />
        ) : (
          <Empty className="emptyIcon" description="No updates available" />
        )}
      </Spin>
    </Drawer>
  );
};

export default ActivityLogs;
